import { render, staticRenderFns } from "./automaticAccess.vue?vue&type=template&id=85d65612&scoped=true"
import script from "./automaticAccess.vue?vue&type=script&lang=js"
export * from "./automaticAccess.vue?vue&type=script&lang=js"
import style0 from "./automaticAccess.vue?vue&type=style&index=0&id=85d65612&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85d65612",
  null
  
)

export default component.exports